import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { FeatureAuth } from 'shell/models/feature-auth';
import { FeatureAuthForm } from 'system/components/feature-auth/form';

export const transformFeatureAuth = (
  response: AxiosResponse<HttpResponse<FeatureAuth>>
): FeatureAuthForm => {
  const data = response.data?.payload;

  const res: FeatureAuthForm = {
    code: data?.key?.codiceFeature || '',
    description: data?.descrizioneTipoFeature || '',
    contextLastUpdate: data?.note || '',
    valuesFeatureAuth: {
      page: 0,
      rowsPerPage: 10,
      orders: {},
      body:
        data?.featureValoreList.map((item) => {
          return {
            code: item.key?.codiceFeature?.toString() || '',
            value: item.key?.valoreAmmesso || '',
            description: item.descrizioneValoreAmmesso || '',
            codeFeature: item.key?.codiceFeature?.toString() || '',
          };
        }) || [],
    },
  };

  return res;
};
